import { makeObservable, observable, computed, action, toJS } from "mobx";
import { UserOrganizationAccess } from "@/endpoints/dryp/user";

export class UserStore {
	private loggedIn = false;
	private user: null | Dryp.User = null;
	private organization: null | Dryp.Organization = null;
	private organizations: UserOrganizationAccess[] = [];

	constructor() {
		makeObservable(this, {
			//@ts-expect-error mobx observable typescript issues
			loggedIn: observable,
			user: observable,
			organization: observable,
			organizations: observable,
			isLoggedIn: computed,
			getUser: computed,
			roles: computed,
			isAdmin: computed,
			isSuperAdmin: computed,
			canEdit: computed,
			setUser: action,
			setLoggedOut: action,
			setLoggedIn: action,
			setUserAndOrganization: action,
		});
	}

	get isLoggedIn() {
		return this.loggedIn;
	}

	get getUser() {
		return toJS(this.user);
	}

	get getOrganization() {
		return toJS(this.organization);
	}

	get getOrganizations() {
		return toJS(this.organizations);
	}

	get roles(): string[] {
		return this.user?.roles ?? [];
	}

	get isAdmin(): boolean {
		return this.roles.includes("Admin");
	}

	get isSuperAdmin(): boolean {
		return this.roles.includes("SuperAdmin");
	}

	get canEdit(): boolean {
		return this.isAdmin;
	}

	setUser(user: Dryp.User) {
		this.user = user;
	}

	setOrganization(organization: Dryp.Organization) {
		this.organization = organization;
	}

	setOrganizations(organizations: UserOrganizationAccess[]) {
		this.organizations = organizations;
	}

	setUserAndOrganization(user: Dryp.User, organization: Dryp.Organization, organizations: UserOrganizationAccess[]) {
		this.setUser(user);
		this.setOrganization(organization);
		this.setOrganizations(organizations);
	}

	setLoggedIn() {
		this.loggedIn = true;
	}
	setLoggedOut() {
		this.loggedIn = false;
	}
}
